export default (props) => {
    const {loading} = props

    return (
        <div className={`${!loading && "hidden"} fixed w-full h-full z-10 bg-secondary flex justify-center items-center`}>
            <img src="/assets/img/loading.gif"></img>
        </div>
    );
}
